var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column_table"},_vm._l((Object.entries(_vm.data)),function(ref,index){
var key = ref[0];
var value = ref[1];
return _c('dl',{key:index,style:({ flexBasis: ("calc(100% / " + _vm.col + ")"), minHeight: (_vm.height + "px") })},[_c('dt',{style:({
        flexBasis: (_vm.width + "px"),
        lineHeight: ((_vm.height - 16) + "px"),
      })},[_c('span',[_vm._v(_vm._s(key))])]),_c('dd',[_c('span',[_vm._v(_vm._s(value))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }